var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('node-view-wrapper',{staticClass:"container",style:(_vm.cssVars)},[_c('node-view-content',{class:_vm.classObject,attrs:{"as":"ol"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }